import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { PURE_SOULS_URL } from "@/lib/site";

/**
 * MobileCTABar — a sticky, thumb-zone action bar shown only on mobile.
 * Keeps the two most useful actions always within easy reach.
 */
export default function MobileCTABar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass-panel border-t border-white/40 px-4 py-3 flex items-center gap-3"
      data-testid="mobile-cta-bar"
    >
      <Link to="/providers" className="btn-primary flex-1" data-testid="mobile-cta-find">
        <MapPin size={16} /> Find a Provider
      </Link>
      <a
        href={PURE_SOULS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-secondary flex-1 bg-white/70"
        data-testid="mobile-cta-puresouls"
      >
        Pure Souls <ArrowUpRight size={15} />
      </a>
    </div>
  );
}
